import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function EditSelfDetails({
  handleToast,
  clientDetails,
  handleLoading,
  closeLoading,
}) {
  const navigate = useNavigate();
  // Initial state with business details
  const [details, setDetails] = useState(clientDetails);

  // State to control password visibility
  const [showPassword, setShowPassword] = useState(false);
  // console.log(clientDetails); 
const [selectedImage, setSelectedImage] = useState(null);
const [previewUrl, setPreviewUrl] = useState(null);


const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setSelectedImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  }
};


const handleImageUpload = async () => {
  if (!selectedImage) {
    handleToast({
      toastMsg: "Please select an image first",
      toastColor: "#FF0000",
    });
    return;
  }

  const formData = new FormData();
  formData.append("image", selectedImage);
  formData.append("hotel_id", details.id);
  formData.append("old_image", details.image);

  try {
    handleLoading();

    const response = await axios.put(
      "https://api.dectwinhotel.com/api/upload-profile-photo",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    closeLoading();

localStorage.removeItem("client_is");
      // console.log(JSON.stringify(response.data));
localStorage.setItem("client_is", JSON.stringify(response.data));
    handleToast({
      toastMsg: "Profile uploaded successfully!",
      toastColor: "#4CAF50",
    });

      navigate("/admin/dashboard");



  } catch (error) {
    closeLoading();
    handleToast({
      toastMsg: "Image upload failed!",
      toastColor: "#FF0000",
    });
  }
};

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    handleLoading();
    // console.log(details);
     const payload = {
    ...details,
    showGST: details.gstin_show,
  };


    try {
      const response = await axios.put(
        "https://api.dectwinhotel.com/api/edit-self",
        payload
      );
      closeLoading();
      localStorage.removeItem("client_is");
      // console.log(response.config.data);
      localStorage.setItem("client_is", response.config.data);
      handleToast({
        toastMsg: "Details Updated Successfully!!!",
        toastColor: "#4CAF50",
      });
      navigate("/admin/dashboard");
    } catch (error) {
      closeLoading();
      handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };

  return (
    <section style={{ padding: "4rem 0rem" }}>
      <div className="add-room-container">
        <form className="edit-details-form" onSubmit={handleSave}>
          <h2 className="form-title">Edit Business Details</h2>

<div className="form-group">

  <div className="text-center">
  {!previewUrl && details.image && (
  <img
    src={`${details.image}`}
    alt="Current"
    style={{ width: "120px", borderRadius: "8px" }}
  />
)}


{/* preview */}
  {previewUrl && (
    <div style={{ marginBottom: "10px" }}>
      <img
        src={previewUrl}
        alt="Preview"
        style={{
          width: "120px",
          height: "120px",
          objectFit: "cover",
          borderRadius: "8px",
          border: "1px solid #ddd",
        }}
      />
    </div>
  )}

  <label>Profile Photo</label>
</div>


  <input
    type="file"
    accept="image/*"
    id="imageInput"
    style={{ display: "none" }}
    onChange={handleImageChange}
  />

  {/* Select Button */}
  <button
    type="button"
    onClick={() => document.getElementById("imageInput").click()}
    className="btn btn-secondary pt-2 pb-1 px-2"
  >
    <i class="fa-regular fa-circle-user"></i>
  </button>



  {/* Upload Button */}
  <button
    type="button"
    onClick={handleImageUpload}
    className="btn btn-success ms-2"
    style={{
      fontSize: '0.8em'
    }}
  >
    Upload Now
  </button>
</div>


          <div className="form-group">
            <label>Hotel ID:</label>
            <input
              type="text"
              name="hotel_id"
              value={details.hotel_id}
              disabled
            />
          </div>

          <div className="form-group">
            <label>Business Name:</label>
            <input
              type="text"
              name="business_name"
              value={details.business_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Business Tagline/Sub Name:</label>
            <input
              type="text"
              name="tagline"
              value={details.tagline || ""}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Contact:</label>
            <input
              type="text"
              name="contact"
              value={details.contact}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>E-Mail:</label>
            <input
              type="text"
              name="gmail"
              value={details.gmail}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Address:</label>
            <input
              type="text"
              name="address"
              value={details.address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>GSTIN Number:</label>
            <input
              type="text"
              name="gstin"
              value={details.gstin || ""}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>OYO Registration Number:</label>
            <input
              type="text"
              name="oyo_reg"
              value={details.oyo_reg || ""}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>FSSAI Licence Number:</label>
            <input
              type="text"
              name="fssai"
              value={details.fssai || ""}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Footer Contents for Invoice:</label>
            <textarea
              name="footer_contents"
              value={details.footer_contents ?? ""}
              onChange={handleChange}
              rows="4"
              placeholder="Enter footer content here to be printed on invoices..."
            />
          </div>

          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={details.name}
              onChange={handleChange}
              required
            />
          </div>

<div className="form-group">
  <label>Default Checkout Time:</label>
  <input
    type="time"
    name="checko_time"
    value={details.checko_time || "00:00"}
    onChange={handleChange}
    required
  />
  <small style={{ color: "#666" }}>
    Guests must checkout by this time on the checkout date.
  </small>
</div>


          <div className="form-group">
            <label>Password:</label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="pass"
                value={details.pass}
                onChange={handleChange}
                required
                style={{ paddingRight: "2rem" }}
              />
              <i
                className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "60%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#555",
                }}
              />
            </div>
          </div>

          <div className="form-group d-flex">
<input
  type="checkbox"
  name="gstin_show"
  style={{ textAlign: 'start', marginLeft: '-16.5em', marginRight: '-15.5em' }}
  checked={details.gstin_show === "1"} // checked if string "1"
  onChange={(e) =>
    setDetails((prev) => ({
      ...prev,
      gstin_show: e.target.checked ? "1" : "0", // save string "1" or "0"
    }))
  }
/>

    <p style={{ whiteSpace: 'nowrap' }} className="my-0 mt-1 fw-semibold">Show GST on Bill</p>
</div>


          <button
            type="submit"
            className="submit-btn-room"
            style={{ width: "100%", backgroundColor: "blueviolet" }}
          >
            Save Changes
          </button>
        </form>
      </div>
    </section>
  );
}

export default EditSelfDetails;
